module.exports = __webpack_public_path__ + "img/renewal-card2.eac3a503.svg";